import { BillingModel } from '../classes/billing';
import { AxiosResponse } from 'axios';
import AuthorizedApiClient from 'modules/auth/models/authorizedApiClient';
import { AppResponse } from 'modules/core/interfaces/appResponse';
import store from '@/store/index';

export class BillingApi {
  public MasterAccountId: string;

  public constructor() {
    this.MasterAccountId = store.state.auth && store.state.auth.user
    ? store.state.auth.user.MasterAccountId
    : null;
  }

  public async getUser(): Promise<BillingModel> {
    const MasterAccountId = this.MasterAccountId;
    const response: AxiosResponse<AppResponse<BillingModel>> = await AuthorizedApiClient.get('/AccountBillingDetails/Get');
    const appResponse: AppResponse<BillingModel> = response.data;

    if (appResponse.IsSuccess) {
      const user: BillingModel = appResponse.Result;
      return user;
    } else {
      throw new Error(appResponse.ErrorCodes.join(','));
    }
  }

  public async updateUser(profile: BillingModel, UpdateStripeCustomer: boolean): Promise<boolean> {
    const MasterAccountId = this.MasterAccountId;
    const response: AxiosResponse<
      AppResponse<any>
    > = await AuthorizedApiClient.post('/AccountBillingDetails/Save', {
      Name: profile.Name,
      // PhoneNumber: profile.PhoneNumber,
      Vatnr: profile.Vatnr,
      Address: profile.Address,
      Postcode: profile.Postcode,
      City: profile.City,
      Country: profile.Country,
      MasterAccountId,
      UpdateStripeCustomer,
    });
    const appResponse: AppResponse<any> = response.data;
    if (appResponse.IsSuccess) {
      return true;
    } else {
      throw new Error(appResponse.ErrorCodes.join(','));
    }
  }
}
